import axios from "axios";
import { BACKEND } from "../../config/configEnvs";

const VerifyQuoteExists = async (quoteId) => {
  if (!quoteId) return false; // Si no hay ID, retornamos falso directamente

  try {
    await axios.get(`${BACKEND}/api/cotizaciones/${quoteId}`);
    return true; // La cotización existe
  } catch (error) {
    if (error.response?.status === 404) return false; // No existe
    throw error; // Si es otro error, lo lanzamos
  }
};

export default VerifyQuoteExists 
